export { default } from './ModalSetPassword';
